import { render, staticRenderFns } from "./UploadAudio.vue?vue&type=template&id=7f0daec8"
import script from "./UploadAudio.vue?vue&type=script&lang=js"
export * from "./UploadAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports